const FILTERS_TO_RESET = [
  "stars",
  "price",
  "query",
  "time",
  "airline",
  "cabinType",
  "type",
  "departureTime",
  "arrivalTime",
];

export { FILTERS_TO_RESET };
